import { FunctionComponent, useState, useEffect } from "react";

interface ShLinearLoadingIndicatorProps {
  isCorrect?: boolean;
}

const ShLinearLoadingIndicator: FunctionComponent<
  ShLinearLoadingIndicatorProps
> = ({ isCorrect }: ShLinearLoadingIndicatorProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        const diff = Math.random() * 3;
        return Math.min(oldProgress + diff, 100);
      });
    }, 15);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 box-border transition-all duration-200 bg-clip-content ease-in-out">
      <div
        className={`rounded-full  ${isCorrect ? "bg-success-500" : "bg-danger-500"} h-2.5 transition-all	duration-200	ease-in-out`}
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  );
};

export default ShLinearLoadingIndicator;
